// extracted by mini-css-extract-plugin
export default {"wrapper":"xQ-z","availablePromoMessagesLabel":"yQ-z","promoMessageList":"zQ-z","promoMessage":"AQ-z","appliedPromoMessage":"BQ-z","promoMessageAmount":"CQ-z"};